module.exports = __webpack_public_path__ + "static/media/7 Sharma SMK 2020_Brief.339eb6e3.pdf";